<template>
  <div class="container fileUploadMultiple fum">
    <b-form id="theForm" class="fum__form">
      <b-form-file
        id="theFiles"
        v-model="files"
        :multiple="true"
        placeholder="Drag and drop files here"
        drop-place-holder="Drag and drop files here"
      />
      <b-button 
        variant="primary" 
        class="mt-2" 
        :disabled="disableAddImageButton" 
        @click="onSubmit()"
      >
        <div v-if="allImagesSaved">
          Images Saved to Request!
        </div>
        <div v-else-if="!isSavingImages">
          Add Files to Request
        </div>
        <div v-else>
          <loading-spinner />
        </div>
      </b-button>
    </b-form>
  </div>
</template>

<script>
  import $ from "jquery";
  import { LoadingSpinner } from "@/components";

  export default {
    name: "FileUploadMultiple",
    components: {
      LoadingSpinner
    },
    props: {
      isSavingImages: {
        type: Boolean,
        default: false
      },
      allImagesSaved: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      files: Array,
    }),
    computed: {
      disableAddImageButton() {
        return this.isSavingImages || (this.files === Array || this.files?.length === 0)
      }
    },
    methods: {
      onSubmit() {
        var formElement = document.forms["theForm"].elements["theFiles"].value;
        var totalFiles = 0;
        var formData = new FormData();
        $.each($("input[type='file']")[0].files, function(i, file) {
          formData.append("file", file);
          totalFiles++;
        })
        
        this.$emit("input-change-multi", formData, totalFiles);
      }
    }
  }
</script>

<style lang="scss">
  .fum__form {
    width: 80%;
    padding: 10px;
    margin: 0 auto;
  }
</style>